import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom';
import './Layout.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const getH = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const SISTEM_MENU = [
  { label: 'Kullanici Yonetimi', route: '/kullanicilar',      ikon: '👤' },
  { label: 'Yetki Yonetimi',     route: '/yetkilendirme',     ikon: '🔐' },
  { label: 'Sayfa Baglantilari', route: '/sayfa-baglantilari', ikon: '🔗' },
  { label: 'Menu Yonetimi',      route: '/menu-yonetimi',      ikon: '🗂️' },
];

export default function Layout() {
  const navigate = useNavigate();
  const loc      = useLocation();
  const userStr  = localStorage.getItem('user');
  const user     = userStr ? JSON.parse(userStr) : null;

  const rolAd: Record<string,string> = {
    super_admin: 'Super Yonetici', gm_yonetici: 'GM Yoneticisi',
    gm_personel: 'GM Personeli',  isletme_mudur: 'Isletme Muduru',
    isletme_personel: 'Isletme Personeli',
  };

  // Tum dugumler ve route map
  const [dugumler,   setDugumler]   = useState<any[]>([]);
  const [kodRoute,   setKodRoute]   = useState<Record<string,string>>({});
  const [menuYuk,    setMenuYuk]    = useState(false);

  // Gosterilen barlar
  const [bar1,      setBar1]      = useState<any[]>([]);  // 1. bar (ust_kod null)
  const [bar2,      setBar2]      = useState<any[]>([]);  // 2. bar (secili ana'nin cocuklari)
  const [sidebar,   setSidebar]   = useState<any[]>([]);  // sidebar (secili alt'in cocuklari)

  // Secili kodlar
  const [seciliAna, setSeciliAna] = useState<string|null>(null);
  const [seciliAlt, setSeciliAlt] = useState<string|null>(null);

  const [sistemAcik, setSistemAcik] = useState(false);
  const [mobileMenuAcik, setMobileMenuAcik] = useState(false);

  // :id iceren rotayi kullanicinin isletme_id'si ile coz
  const cozRoute = (r: string) => {
    if (!r.includes(':id')) return r;
    const isletmeId = user?.isletme_id;
    if (isletmeId) return r.replace(':id', String(isletmeId));
    return '/bos';
  };

  // menu_agac'tan veri cek
  const menuYukle = () => {
    fetch(`${API}/api/sayfa-route/menu-agac`, { headers: getH() })
      .then(r => r.ok ? r.json() : { dugumler: [], kod_route: {} })
      .then((d: any) => {
        const tum: any[] = d.dugumler || [];
        setDugumler(tum);
        setKodRoute(d.kod_route || {});
        setBar1(tum.filter((x: any) => !x.ust_kod).sort((a:any,b:any) => a.sira - b.sira));
        setMenuYuk(true);
      })
      .catch(() => setMenuYuk(true));
  };

  useEffect(() => {
    menuYukle();
    window.addEventListener('menu-guncellendi', menuYukle);
    return () => window.removeEventListener('menu-guncellendi', menuYukle);
  }, []);

  // 1. bara tikla: 2. bar'i goster, sayfaya gitme
  const handleAnaClick = (mod: any) => {
    if (seciliAna === mod.kod) {
      setSeciliAna(null);
      setBar2([]);
      setSidebar([]);
      setSeciliAlt(null);
      return;
    }
    setSeciliAna(mod.kod);
    setSeciliAlt(null);
    setSidebar([]);
    const cocuklar = dugumler
      .filter(d => d.ust_kod === mod.kod)
      .sort((a, b) => a.sira - b.sira);
    setBar2(cocuklar);

    if (cocuklar.length === 0 && kodRoute[mod.kod]) {
      navigate(cozRoute(kodRoute[mod.kod]));
      setMobileMenuAcik(false);
    }
  };

  // 2. bara tikla: sidebar'i goster, sayfaya gitme
  const handleAltClick = (alt: any) => {
    if (seciliAlt === alt.kod) {
      setSeciliAlt(null);
      setSidebar([]);
      return;
    }
    setSeciliAlt(alt.kod);
    const cocuklar = dugumler
      .filter(d => d.ust_kod === alt.kod)
      .sort((a, b) => a.sira - b.sira);
    setSidebar(cocuklar);

    // Cocuk yoksa sayfaya git, route da yoksa icerigi temizle
    if (cocuklar.length === 0 && kodRoute[alt.kod]) {
      navigate(cozRoute(kodRoute[alt.kod]));
    } else if (cocuklar.length === 0) {
      navigate('/bos');
    }
  };

  // Sidebar'a tikla: sayfaya git
  const handleSidebarClick = (item: any) => {
    const r = kodRoute[item.kod];
    if (r) navigate(cozRoute(r));
    else navigate('/bos');
  };

  // URL degisince aktif menuyu guncelle
  useEffect(() => {
    if (!menuYuk) return;
    const p = loc.pathname;

    // Ana sayfaya donunce bar2/sidebar temizle
    setMobileMenuAcik(false);
    if (p === '/') {
      setSeciliAna(null);
      setSeciliAlt(null);
      setBar2([]);
      setSidebar([]);
      return;
    }

    // Sistem sayfalarinda bar2/sidebar kapat
    if (SISTEM_MENU.some(m => p.startsWith(m.route))) {
      return; // sidebar ve bar2 oldugu gibi kalsin
    }

    // Hangi kod aktif?
    let aktifKod: string | null = null;
    let enIyi = -1;
    for (const [kod, route] of Object.entries(kodRoute)) {
      const rp = route.split('?')[0];
      if ((p === rp || p.startsWith(rp + '/')) && rp.length > enIyi) {
        enIyi = rp.length; aktifKod = kod;
      }
    }
    if (!aktifKod) return;

    // Aktif dugumun ana ve alt kodunu bul
    const dugum = dugumler.find(d => d.kod === aktifKod);
    if (!dugum) return;

    if (!dugum.ust_kod) {
      // Seviye 0
      setSeciliAna(dugum.kod);
    } else {
      const ust = dugumler.find(d => d.kod === dugum.ust_kod);
      if (ust && !ust.ust_kod) {
        // Seviye 1
        setSeciliAna(ust.kod);
        setSeciliAlt(dugum.kod);
        setBar2(dugumler.filter(d => d.ust_kod === ust.kod).sort((a,b) => a.sira - b.sira));
        setSidebar(dugumler.filter(d => d.ust_kod === dugum.kod).sort((a,b) => a.sira - b.sira));
      } else if (ust) {
        // Seviye 2
        const ust2 = dugumler.find(d => d.kod === ust.ust_kod);
        if (ust2) setSeciliAna(ust2.kod);
        setSeciliAlt(ust.kod);
        setBar2(dugumler.filter(d => d.ust_kod === (ust2?.kod)).sort((a,b) => a.sira - b.sira));
        setSidebar(dugumler.filter(d => d.ust_kod === ust.kod).sort((a,b) => a.sira - b.sira));
      }
    }
  }, [loc.pathname, menuYuk, dugumler, kodRoute]);

  const handleLogout = () => {
    localStorage.removeItem('token'); localStorage.removeItem('user');
    navigate('/login');
  };

  const sistemAktif = SISTEM_MENU.some(m => loc.pathname.startsWith(m.route));

  return (
    <div className="layout">
      {mobileMenuAcik && (
        <div className="mobile-overlay" onClick={() => setMobileMenuAcik(false)} />
      )}
      <div className="topbar">
        <div className="topbar-left">
          <button
            className="hamburger-btn"
            onClick={() => setMobileMenuAcik(v => !v)}
            aria-label="Menü"
          >
            <span></span><span></span><span></span>
          </button>
          <div className="logo">
            <span className="logo-tigem">TİGEM</span>
            <span className="logo-erp">SGB</span>
          </div>
        </div>
        <div className="topbar-right">
          <span className="user-info">
            <span className="user-name">{user?.ad_soyad}</span>
            <span className="user-rol">{rolAd[user?.rol] || user?.rol}</span>
          </span>
          <button className="logout-btn" onClick={handleLogout}>Çıkış</button>
        </div>
      </div>

      {/* 1. BAR */}
      <div className={`navbar${mobileMenuAcik ? ' mobile-open' : ''}`}>
        <Link to="/" className={`navbar-item ${loc.pathname === '/' ? 'active' : ''}`}
          onClick={() => { setSeciliAna(null); setSeciliAlt(null); setBar2([]); setSidebar([]); }}
        >
          <span className="navbar-icon">🏠</span>
          <span className="navbar-label">Ana Sayfa</span>
        </Link>

        {menuYuk ? bar1.map(mod => (
          <button key={mod.kod}
            className={`navbar-item ${seciliAna === mod.kod ? 'active' : ''}`}
            onClick={() => handleAnaClick(mod)}
          >
            <span className="navbar-icon">{mod.ikon || '📋'}</span>
            <span className="navbar-label">{mod.ad}</span>
          </button>
        )) : <span style={{color:'#aed6f1',padding:'0 12px',fontSize:12}}>...</span>}

        <div className="navbar-spacer" />

        <button
          className={`navbar-item sistem-btn ${sistemAktif || sistemAcik ? 'active' : ''}`}
          onClick={() => setSistemAcik(v => !v)}
        >
          <span className="navbar-icon">⚙️</span>
          <span className="navbar-label">Sistem Ayarlari</span>
          <span style={{fontSize:10,marginLeft:3}}>{sistemAcik ? '▲' : '▼'}</span>
        </button>

        {sistemAcik && (
          <div className="sistem-inline">
            {SISTEM_MENU.map(m => (
              <Link key={m.route} to={m.route}
                className={`navbar-item ${loc.pathname.startsWith(m.route) ? 'active' : ''}`}
                onClick={() => setSistemAcik(false)}
              >
                {m.ikon} {m.label}
              </Link>
            ))}
          </div>
        )}
      </div>

      {/* 2. BAR */}
      {bar2.length > 0 && (
        <div className="subbar">
          {bar2.map(alt => (
            <button key={alt.kod}
              className={`subbar-item ${seciliAlt === alt.kod ? 'active' : ''}`}
              onClick={() => handleAltClick(alt)}
            >
              <span>{alt.ikon || '📄'}</span>
              <span>{alt.ad}</span>
            </button>
          ))}
        </div>
      )}

      {/* ICERIK */}
      <div className="main-container">
        {sidebar.length > 0 && (
          <div className="sidebar">
            <div className="sidebar-title">
              {bar2.find(a => a.kod === seciliAlt)?.ad || ''}
            </div>
            {sidebar.map(item => {
              const r = kodRoute[item.kod] || '/bos';
              const aktif = loc.pathname === r.split('?')[0];
              return (
                <div key={item.kod}
                  className={`sidebar-item ${aktif ? 'active' : ''}`}
                  onClick={() => handleSidebarClick(item)}
                >
                  <span className="sidebar-icon">{item.ikon || '📌'}</span>
                  <span className="sidebar-label">{item.ad}</span>
                </div>
              );
            })}
          </div>
        )}
        <div className="content"><Outlet /></div>
      </div>
    </div>
  );
}
